import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "subtasks",
  "use": "subtasks-usage",
  "viewBox": "0 0 11 11",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 11\" id=\"subtasks\"><g fill=\"none\" fill-rule=\"evenodd\" stroke-width=\".9\" transform=\"translate(1)\"><circle cx=\"8.5\" cy=\"5\" r=\"1.05\" /><circle cx=\"8.5\" cy=\"9\" r=\"1.05\" /><path d=\"M0 0v6a3 3 0 0 0 3 3h4\" /><path d=\"M0 0v2a3 3 0 0 0 3 3h4\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol